<template>
  <div class="work-space-item">
    <v-row
      v-for="(workSchedule, i) in workSchedulesList"
      :key="workSchedule.id"
      class="align-center"
    >
      <v-col cols="4">
        <div class="d-flex align-center">
          <div class="avatars d-flex flex-column">
            <avatar :user="getEmployee(firstEmployee)"/>
          </div>
          <div class="select-section">
            <v-select
              v-model="firstEmployee"
              @change="setStaff"
              :items="workspace.users"
              item-text="name"
              item-value="id"
              hide-details="auto"
              item-color="#ff9100"
              class="select"
              solo
              height="42"
              full-width
            />
          </div>
        </div>
      </v-col>
      <v-col cols="5">
      </v-col>
      <v-col cols="3">
        <div class="staff-radio">
          <v-radio-group v-model="shiftTime" @change="setStaff">
            <v-radio
              value="full"
              name="shiftTimes"
              label="Полная смена"
              class="radio-button"
              :ripple="false"
            />
            <v-radio
              value="half"
              name="shiftTimes"
              label="Пол смены"
              class="radio-button"
              :ripple="false"
            />
          </v-radio-group>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'WorkSpaceItem',
    props: {
      workSpace: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      workSchedulesList () {
        return this.workSpace.workSchedules || []
      },
      usersList () {
        return this.workSpace.users || []
      },
    },
  }
</script>
